<template>
  <div class="login-wrapper join">
    <a class="logo logo_type_c" v-if="isBrosaib"></a>
    <form class="login join">
      <label>
        이름
        <span v-if="details.username" style="color: red;">({{ details.username }})</span>
      </label>
      <a-input
        v-model="auth.username"
        placeholder="고객님의 이름을 입력해주세요."
        autocomplete="username"
        class="ipt_type_1 email"
        :disabled="isLoading"
      />

      <label>
        아이디
        <span v-if="details.identity" style="color: red;">({{ details.identity }})</span>
      </label>
      <a-input
        v-model="auth.identity"
        placeholder="로그인시 사용되는 아이디를 입력해주세요."
        autocomplete="username"
        class="ipt_type_1 email"
        :disabled="isLoading"
      />

      <label>
        비밀번호
        <span v-if="details.password" style="color: red;">({{ details.password }})</span>
      </label>
      <a-input
        v-model="auth.password"
        placeholder="로그인시 사용되는 비밀번호를 입력해주세요."
        autocomplete="new-password"
        class="ipt_type_1 password"
        :disabled="isLoading"
        type="password"
      />

      <label>
        비밀번호 재입력
        <span
          v-if="details.repeatPassword"
          style="color: red;"
        >({{ details.repeatPassword }})</span>
      </label>
      <a-input
        v-model="auth.repeatPassword"
        placeholder="비밀번호를 재입력해주세요."
        autocomplete="new-password"
        class="ipt_type_1 password"
        :disabled="isLoading"
        type="password"
      />

      <label>
        이메일
        <span v-if="details.email" style="color: red;">({{ details.email }})</span>
      </label>
      <a-input
        v-model="auth.email"
        placeholder="사용하시는 이메일을 입력해주세요."
        autocomplete="email"
        class="ipt_type_1 email"
        :disabled="isLoading"
        type="email"
      />

      <label>
        휴대폰 번호
        <span v-if="details.phone" style="color: red;">({{ details.phone }})</span>
      </label>
      <a-input
        v-model="auth.phone"
        @input="getMask('phone')"
        type="text"
        autocomplete="tel"
        placeholder="사용하시는 휴대폰 번호를 입력해주세요."
        class="ipt_type_1 email"
        :disabled="isLoading"
      />

      <label>
        상호명
        <span
          v-if="details.business && details.business.name"
          style="color: red;"
        >({{ details.business.name }})</span>
      </label>
      <a-input
        v-model="auth.business.name"
        type="text"
        autocomplete="on"
        placeholder="매장 이름을 입력해주세요."
        class="ipt_type_1 email"
        :disabled="isLoading"
      />
      <label>
        전화번호
        <span
          v-if="details.business && details.business.phone"
          style="color: red;"
        >({{ details.business.phone }})</span>
      </label>
      <a-input
        v-model="auth.business.phone"
        @input="getMask('phone', true)"
        type="text"
        autocomplete="tel"
        placeholder="매장 전화번호를 입력해주세요."
        class="ipt_type_1 email"
        :disabled="isLoading"
      />
      <label>
        홈페이지
        <span
          v-if="details.business && details.business.homepage"
          style="color: red;"
        >({{ details.business.homepage }})</span>
      </label>
      <a-input
        v-model="auth.business.homepage"
        type="text"
        autocomplete="url"
        placeholder="홈페이지 주소를 입력해주세요."
        class="ipt_type_1 email"
        :disabled="isLoading"
      />

      <label>
        주소
        <span
          v-if="details.business && details.business.address"
          style="color: red;"
        >({{ details.business.address }})</span>
      </label>
      <a-input
        v-model="auth.business.address"
        type="text"
        autocomplete="street-address"
        placeholder="매장 주소를 입력해주세요."
        class="ipt_type_1 email"
        :disabled="isLoading"
      />

      <div class="btn_wrapper">
        <a
          class="btn_type_1 ef_type_2"
          @click="submit"
          :disabled="isLoading"
        >{{ !isLoading ? '회원가입' : '회원가입 중...' }}</a>

        <div class="login_btn_wrapper">
          <router-link to="/signin" class="a_type_1 text-center">로그인</router-link>&nbsp;
          <router-link to="/find" class="a_type_1 text-center">비밀번호 찾기</router-link>&nbsp;
          <router-link to="/uncle" class="a_type_1 text-center">사입삼촌</router-link>&nbsp;
          <router-link to="/admin" class="a_type_1 text-center">관리자</router-link>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import config from "../../config";

export default {
  name: "AuthSignin",
  data() {
    return {
      isLoading: false /* 로딩 상태 */,
      details: {
        business: {}
      },
      auth: {
        identity: "",
        password: "",
        repeatPassword: "",
        username: "",
        email: "",
        phone: "",
        business: {
          name: "",
          phone: "",
          homepage: "",
          address: ""
        }
      }
    };
  },
  methods: {
    ...mapActions(["signup"]),
    getMask(type, isBusiness = false) {
      let num = !isBusiness ? this.auth[type] : this.auth.business[type];

      num = num.replace(/[^0-9]/g, "");
      let res = "";
      if (num.length < 3) {
        res = num;
      } else {
        if (num.substr(0, 2) == "02") {
          if (num.length <= 5) {
            //02-123-5678
            res = num.substr(0, 2) + "-" + num.substr(2, 3);
          } else if (num.length > 5 && num.length <= 9) {
            //02-123-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 3) + "-" + num.substr(5);
          } else if (num.length > 9) {
            //02-1234-5678
            res =
              num.substr(0, 2) + "-" + num.substr(2, 4) + "-" + num.substr(6);
          }
        } else {
          if (num.length < 8) {
            res = num;
          } else if (num.length == 8) {
            res = num.substr(0, 4) + "-" + num.substr(4);
          } else if (num.length == 9) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length == 10) {
            res =
              num.substr(0, 3) + "-" + num.substr(3, 3) + "-" + num.substr(6);
          } else if (num.length > 10) {
            //010-1234-5678
            res =
              num.substr(0, 3) + "-" + num.substr(3, 4) + "-" + num.substr(7);
          }
        }
      }

      if (isBusiness) this.auth.business[type] = res;
      else this.auth[type] = res;
    },
    async submit() {
      try {
        this.isLoading = true;
        const isSuccess = await this.signup(this.auth);
        if (!isSuccess) this.details = this.$store.state.auth.details;
      } catch (e) {
        config.alert.mixin({
          type: "warning",
          title: "오류가 발생했습니다."
        });
      }
      this.isLoading = false;
    }
  }
};
</script>